import React from "react";
import styles from "./ChatHistory.module.css";
import clsx from "clsx";
import ChatDialog from "../../../../../components/popUp/popUpChatHistory/ChatDialog";
import Metadata from "../questionList/components/metaData/Metadata";
import Card from "../../../../../components/card/Card";
import { setChatActive } from "../../../../../store/chat.slice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";
import {
  ChatConversation,
  ChatMessage,
} from "../../../../../api/responsePayload/ChatResponse";

interface ChatHistoryProps {}

const ChatHistory: React.FC<ChatHistoryProps> = ({}) => {
  const dispatch = useAppDispatch();
  const chatHistoryList = useAppSelector((s) => s.chat.chatHistory);

  return (
    <div className={styles["parent-scroll-container"]}>
      {chatHistoryList.map((data: ChatConversation, index: number) => (
        <Card key={index} isActive={data.endReason == 0}>
          <Metadata
            text={`ConversationId: ${data.conversationId} \n MemberId: ${data.memberId}`}
          />
          {data.messages.map((message: ChatMessage, i: number) => (
            <div key={i} className={clsx(styles["message-container"])}>
              <ChatDialog
                id={message.id}
                type={message.role}
                datetime={message.createdAt}
                message={message.text}
                isActive={message.isActive}
                image={message.images}
                replyId={message.inReplyTo}
                adminAction={message.adminAction}
                onClickCallback={(clickedId: string | number) => {
                  dispatch(
                    setChatActive({
                      conversationId: data.conversationId,
                      clickedId,
                    })
                  );
                }}
              />
            </div>
          ))}
        </Card>
      ))}
    </div>
  );
};

export default ChatHistory;
